import React from "react";

import UsageSkeleton from "./UsageSkeleton";

/**
 * The four headline tiles, before the numbers arrive. The same band opens the
 * fleet page and a single tenant's report, and both put different cards under
 * it — so the band is shared and the rest stays with the screen.
 */
const UsageStatBandSkeleton = ({ count = 4 }) => (
  <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
    {Array.from({ length: count }).map((_, index) => (
      <UsageSkeleton key={index} className="h-[86px] w-full" />
    ))}
  </div>
);

export default UsageStatBandSkeleton;
